import { Redirect, Route, Switch } from 'react-router';
import Report from './pages/leads/list/Report';
import UserGuide from './pages/userguide';
import UserGuideMC02 from './pages/userguidemc02';
import React from 'react';
import ValidateLogin from './pages/ValidateLogin';
import Logout from './pages/Logout';
import Profile from './pages/profile';
import Home from './pages/Home';
import _400 from './pages/4xx/400';
import BankStaffReport from './pages/leads/list/BankStaff';
import UserList from './pages/users/UserList';
import ConfigListPage from './pages/report-configs';
import ConfigItem from './pages/report-configs/Detail';
import ContestList from './pages/contest';
import ContextDetail from './pages/contest/Detail';
import NewLead from './pages/leads/New';
import ViewLead from './pages/leads/View';

import { connect } from 'react-redux';
import _404 from './pages/4xx/404';
import ForgetPassword from './pages/forget-password';
import ReportPolicyNew from './pages/bankportal/report/ReportPolicyNew';
import ReportPolicyCreditLife from './pages/bankportal/report/ReportPolicyCreditLife';
import ReportPolicyOnline from './pages/bankportal/report/ReportPolicyOnline';
import ReportLeadTracking from './pages/bankportal/report/ReportLeadTracking';
import ReportFYP from './pages/bankportal/report/ReportFYP';
import ReportRYP from './pages/bankportal/report/ReportRYP';
import ReportPolicyInforced from './pages/bankportal/report/ReportPolicyInforced';
import ReportPolicyLapsed from './pages/bankportal/report/ReportPolicyLapsed';
import ReportPolicyExpired from './pages/bankportal/report/ReportPolicyExpired';
import ReportPolicyClaim from './pages/bankportal/report/ReportPolicyClaim';
import BankfeeList from './pages/bankportal/bankfee/BankfeeList';
import BankfeeDetail from './pages/bankportal/bankfee/BankfeeDetail';
import BankfeeSchedulerVCBUpdate from './pages/bankportal/bankfee/BankfeeSchedulerVCBUpdate';
import BankfeeSchedulerAGBUpdate from './pages/bankportal/bankfee/BankfeeSchedulerAGBUpdate';
import BPUserList from './pages/bankportal/user/BPUserList';
import BPUserEdit from './pages/bankportal/user/BPUserEdit';
import BPUserCreate from './pages/bankportal/user/BPUserCreate';
import HDBReportPolicyNew from './pages/bankportal/report/HDBReportPolicyNew';
import HDBReportFYP from './pages/bankportal/report/HDBReportFYP';
import HDBReportRYP from './pages/bankportal/report/HDBReportRYP';
import HDBReportPolicyInforced from './pages/bankportal/report/HDBReportPolicyInforced';
import AGBReportPolicyNew from './pages/bankportal/report/AGBReportPolicyNew';
import AGBReportFYP from './pages/bankportal/report/AGBReportFYP';
import AGBReportLeadTracking from './pages/bankportal/report/AGBReportLeadTracking';
import BPContestList from './pages/bankportal/contest/BPContestList';
import BPContestEdit from './pages/bankportal/contest/BPContestEdit';
import BPContestCreate from './pages/bankportal/contest/BPContestCreate';
import BPContestDetail from './pages/bankportal/contest/BPContestDetail';
import BPPhaseCreate from './pages/bankportal/contest/BPPhaseCreate';
import BPPhaseDetail from './pages/bankportal/contest/BPPhaseDetail';
import BPPhaseEdit from './pages/bankportal/contest/BPPhaseEdit';
import BPContestFileCreate from './pages/bankportal/contest/BPContestFileCreate';
import BPHDBReportProposal from './pages/bankportal/hdb/BPHDBReportProposal';
import BPHDBReportPolicyIssue from './pages/bankportal/hdb/BPHDBReportPolicyIssue';
import BPHDBReportPolicyPending from './pages/bankportal/hdb/BPHDBReportPolicyPending';
import BPHDBReportPolicyCancel from './pages/bankportal/hdb/BPHDBReportPolicyCancel';
import BPHDBReportPolicyReject from './pages/bankportal/hdb/BPHDBReportPolicyReject';
import BPHDBReportPolicyFypDaily from './pages/bankportal/hdb/BPHDBReportPolicyFypDaily';
import BPHDBReportPolicyFypMonthly from './pages/bankportal/hdb/BPHDBReportPolicyFypMonthly';
import BPHDBReportPolicyIssueMonthly from './pages/bankportal/hdb/BPHDBReportPolicyIssueMonthly';
import BPHDBReportPolicyCustomerInfo from './pages/bankportal/hdb/BPHDBReportPolicyCustomerInfo';
import BPHDBReportPolicyLapse from './pages/bankportal/hdb/BPHDBReportPolicyLapse';
import BPHDBReportPolicyRenewal from './pages/bankportal/hdb/BPHDBReportPolicyRenewal';
import BPHDBReportPolicyRemindPtd from './pages/bankportal/hdb/BPHDBReportPolicyRemindPtd';
import NAB_ReportPolicyNew from './pages/bankportal/report/NAB_ReportPolicyNew';
import NAB_ReportLeadTracking from './pages/bankportal/report/NAB_ReportLeadTracking';
import NAB_ReportFYP from './pages/bankportal/report/NAB_ReportFYP';
import NAB_ReportRYP from './pages/bankportal/report/NAB_ReportRYP';
import BPVCBReportCustomerPriority from "./pages/bankportal/vcb/BPVCBReportCustomerPriority";
import { default as CorporateLeadList } from './features/corporate-lead/List';
import { default as CorporateLeadNew } from './features/corporate-lead/New';
import { default as CorporateLeadView } from './features/corporate-lead/View';
import BankPolicyList from './pages/policy/BankPolicyList';
import MonthlyIssuedList from './pages/policy/monthly-issued/MonthlyIssuedList';
import VcbBotoSalePerformance from './pages/bankportal/report/VcbBotoSalePerformance';
import VcbBankerSalePerformance from './pages/bankportal/report/VcbBankerSalePerformance';
import VcbSalePerformanceUploadList from './pages/bankportal/report/upload/VcbSalePerformanceUploadList';
import VcbSalePerformanceUploadCreate from './pages/bankportal/report/upload/VcbSalePerformanceUploadCreate';

export const CREATE_LEAD_URL = '/lead';
export const LEAD_REPORT_URL = '/leads';
export const READ_LEAD_URL = '/leads/:leadId';
export const USER_GUIDE_URL = '/userguide';
export const USER_GUIDE_MC02_URL = '/userguidemc02';
export const NOT_FOUND_URL = '/404';
export const BAD_REQUEST_URL = '/400';
export const PROFILE_URL = '/profile';
export const FORGET_PASSWORD_URL = '/forget-password';
export const LOGIN_URL = '/login';
export const LOGOUT_URL = '/logout';
export const REPORT_URL = '/report';
export const POLICY_REPORT_URL = '/policies';
export const MONTHLY_ISSUED_REPORT_URL = '/monthly-issued-policies';

export const LIST_USER_URL = '/users';
export const REPORT_CONFIG_LIST_URL = '/report-configs';
export const REPORT_CONFIG_ITEM_URL = '/report-configs/:code';

export const CONTEST_LIST_URL = '/contest';
export const CONTEST_URL = '/contest/:id';

export const BANK_PORTAL_REPORT_POLICY_NEW = '/bp/report/new';
export const BANK_PORTAL_REPORT_POLICY_CREDITLIFE = '/bp/report/creditLife';
export const BANK_PORTAL_REPORT_POLICY_ONLINE = '/bp/report/online';
export const BANK_PORTAL_REPORT_LEAD_TRACKING = '/bp/report/lead';
export const BANK_PORTAL_REPORT_FYP = '/bp/report/fyp';
export const BANK_PORTAL_REPORT_RYP = '/bp/report/ryp';
export const BANK_PORTAL_REPORT_POLICY_INFORCED = '/bp/report/inforced';
export const BANK_PORTAL_REPORT_POLICY_EXPIRED = '/bp/report/expired';
export const BANK_PORTAL_REPORT_POLICY_LAPSED = '/bp/report/lapsed';
export const BANK_PORTAL_REPORT_POLICY_CLAIM = '/bp/report/claim';
export const BANK_PORTAL_BANKFEE_LIST = '/bp/bankfee';
export const BANK_PORTAL_BANKFEE_DETAIL = '/bp/bankfee/detail/:bankfeeId';
export const BANK_PORTAL_BANKFEE_SCHEDULER_VCB_UPDATE = '/bp/bankfee/scheduler/vcb';
export const BANK_PORTAL_BANKFEE_SCHEDULER_AGB_UPDATE = '/bp/bankfee/scheduler/agb';
export const BANK_PORTAL_USER_LIST = '/bp/user/list';
export const BANK_PORTAL_USER_EDIT = '/bp/user/edit/:userId';
export const BANK_PORTAL_USER_CREATE = '/bp/user/create';
export const BANK_PORTAL_REPORT_POLICY_NEW_HDB_DIRECTSALE = '/bp/report/new/hdb/directsale';
export const BANK_PORTAL_REPORT_FYP_HDB_DIRECTSALE = '/bp/report/fyp/hdb/directsale';
export const BANK_PORTAL_REPORT_RYP_HDB_DIRECTSALE = '/bp/report/ryp/hdb/directsale';
export const BANK_PORTAL_REPORT_INFORCED_HDB_DIRECTSALE = '/bp/report/inforced/hdb/directsale';
export const BANK_PORTAL_REPORT_POLICY_NEW_AGB = '/bp/report/new/agb';
export const BANK_PORTAL_REPORT_FYP_AGB = '/bp/report/fyp/agb';
export const BANK_PORTAL_REPORT_LEAD_AGB = '/bp/report/lead/agb';
export const BANK_PORTAL_CONTEST_LIST = '/bp/contest';
export const BANK_PORTAL_CONTEST_EDIT = '/bp/contest/:contestId/edit';
export const BANK_PORTAL_CONTEST_CREATE = '/bp/contest/create';
export const BANK_PORTAL_CONTEST_DETAIL = '/bp/contest/:contestId/detail';
export const BANK_PORTAL_PHASE_CREATE = '/bp/contest/:contestId/phase/create';
export const BANK_PORTAL_PHASE_DETAIL = '/bp/contest/phase/:contestPhaseId/detail';
export const BANK_PORTAL_PHASE_EDIT = '/bp/contest/phase/:phaseId/edit';
export const BANK_PORTAL_CONTEST_FILE_CREATE = '/bp/contest/:contestId/phase/:phaseId/file/create';

export const BANK_PORTAL_REPORT_HDB_POLICY_PROPOSAL = '/bp/report/hdb/policy/proposal';
export const BANK_PORTAL_REPORT_HDB_POLICY_ISSUE = '/bp/report/hdb/policy/issue';
export const BANK_PORTAL_REPORT_HDB_POLICY_PENDING = '/bp/report/hdb/policy/pending';
export const BANK_PORTAL_REPORT_HDB_POLICY_CANCEL = '/bp/report/hdb/policy/cancel';
export const BANK_PORTAL_REPORT_HDB_POLICY_REJECT = '/bp/report/hdb/policy/reject';
export const BANK_PORTAL_REPORT_HDB_POLICY_FYP_DAILY = '/bp/report/hdb/policy/fyp-daily';
export const BANK_PORTAL_REPORT_HDB_POLICY_FYP_MONTHLY = '/bp/report/hdb/policy/fyp-monthly';
export const BANK_PORTAL_REPORT_HDB_POLICY_ISSUE_MONTHLY = '/bp/report/hdb/policy/issue-monthly';
export const BANK_PORTAL_REPORT_HDB_POLICY_CUSTOMER_INFO = '/bp/report/hdb/policy/customer-info';
export const BANK_PORTAL_REPORT_HDB_POLICY_LAPSE = '/bp/report/hdb/policy/lapse';
export const BANK_PORTAL_REPORT_HDB_POLICY_RENEWAL = '/bp/report/hdb/policy/renewal';
export const BANK_PORTAL_REPORT_HDB_POLICY_REMIND_PAIDTODATE = '/bp/report/hdb/policy/remind-ptd';

export const BANK_PORTAL_REPORT_NAB_POLICY_NEW = '/bp/report/new/nab';
export const BANK_PORTAL_REPORT_NAB_LEAD_TRACKING = '/bp/report/lead/nab';
export const BANK_PORTAL_REPORT_NAB_FYP = '/bp/report/fyp/nab';
export const BANK_PORTAL_REPORT_NAB_RYP = '/bp/report/ryp/nab';
export const BANK_PORTAL_REPORT_VCB_CUSTOMER_PRIORITY = '/bp/report/vcb/policy/customer-priority';

export const CORPORATE_LEAD_LIST = '/corporate-leads';
export const CORPORATE_LEAD_NEW = '/corporate-leads/new';
export const CORPORATE_LEAD_VIEW = '/corporate-leads/view/:seq';

export const BANK_PORTAL_REPORT_VCB_BOTO_SALE_PERFORMANCE = '/bp/report/vcb/sale/performance/boto';
export const BANK_PORTAL_REPORT_VCB_BANKER_SALE_PERFORMANCE = '/bp/report/vcb/sale/performance/banker';
export const BANK_PORTAL_SALE_PERFORMANCE_UPLOAD_LIST = '/bp/salePerformance/upload/list';
export const BANK_PORTAL_SALE_PERFORMANCE_UPLOAD_CREATE = '/bp/salePerformance/upload/create';

export const Routes = ({ bank }) => {
  return (
    <Switch>
      <Route
        exact
        path={CONTEST_LIST_URL}
        render={(props) => (bank === 'AGR' ? <ContestList {...props} /> : <Redirect to={NOT_FOUND_URL} />)}
      />

      <Route
        exact
        path={CONTEST_URL}
        render={(props) => (bank === 'AGR' ? <ContextDetail {...props} /> : <Redirect to={NOT_FOUND_URL} />)}
      />

      <Route exact path={LIST_USER_URL} component={UserList} />
      <Route exact path={REPORT_CONFIG_LIST_URL} component={ConfigListPage} />
      <Route exact path={REPORT_CONFIG_ITEM_URL} component={ConfigItem} />

      <Route exact path={REPORT_URL} component={BankStaffReport} />

      <Route exact path={CREATE_LEAD_URL} component={NewLead} />
      <Route exact path={READ_LEAD_URL} component={ViewLead} />
      <Route exact path={LEAD_REPORT_URL} component={Report} />

      <Route exact path={POLICY_REPORT_URL} component={BankPolicyList} />
      <Route exact path={MONTHLY_ISSUED_REPORT_URL} component={MonthlyIssuedList} />

      <Route exact path={USER_GUIDE_URL} component={UserGuide} />
      <Route exact path={USER_GUIDE_MC02_URL} component={UserGuideMC02} />
      <Route exact path={PROFILE_URL} component={Profile} />

      <Route exact path={FORGET_PASSWORD_URL} component={ForgetPassword} />

      <Route exact path={NOT_FOUND_URL} component={_404} />
      <Route exact path={BAD_REQUEST_URL} component={_400} />

      <Route exact path={LOGIN_URL} component={ValidateLogin} />
      <Route exact path={LOGOUT_URL} component={Logout} />

      <Route exact path={BANK_PORTAL_REPORT_POLICY_NEW} component={ReportPolicyNew} />
      <Route exact path={BANK_PORTAL_REPORT_POLICY_CREDITLIFE} component={ReportPolicyCreditLife} />
      <Route exact path={BANK_PORTAL_REPORT_POLICY_ONLINE} component={ReportPolicyOnline} />
      <Route exact path={BANK_PORTAL_REPORT_LEAD_TRACKING} component={ReportLeadTracking} />
      <Route exact path={BANK_PORTAL_REPORT_FYP} component={ReportFYP} />
      <Route exact path={BANK_PORTAL_REPORT_RYP} component={ReportRYP} />
      <Route exact path={BANK_PORTAL_REPORT_POLICY_INFORCED} component={ReportPolicyInforced} />
      <Route exact path={BANK_PORTAL_REPORT_POLICY_LAPSED} component={ReportPolicyLapsed} />
      <Route exact path={BANK_PORTAL_REPORT_POLICY_EXPIRED} component={ReportPolicyExpired} />
      <Route exact path={BANK_PORTAL_REPORT_POLICY_CLAIM} component={ReportPolicyClaim} />
      <Route exact path={BANK_PORTAL_BANKFEE_LIST} component={BankfeeList} />
      <Route exact path={BANK_PORTAL_BANKFEE_DETAIL} component={BankfeeDetail} />
      <Route exact path={BANK_PORTAL_BANKFEE_SCHEDULER_VCB_UPDATE} component={BankfeeSchedulerVCBUpdate} />
      <Route exact path={BANK_PORTAL_BANKFEE_SCHEDULER_AGB_UPDATE} component={BankfeeSchedulerAGBUpdate} />
      <Route exact path={BANK_PORTAL_USER_LIST} component={BPUserList} />
      <Route exact path={BANK_PORTAL_USER_EDIT} component={BPUserEdit} />
      <Route exact path={BANK_PORTAL_USER_CREATE} component={BPUserCreate} />
      <Route exact path={BANK_PORTAL_REPORT_POLICY_NEW_HDB_DIRECTSALE} component={HDBReportPolicyNew} />
      <Route exact path={BANK_PORTAL_REPORT_FYP_HDB_DIRECTSALE} component={HDBReportFYP} />
      <Route exact path={BANK_PORTAL_REPORT_RYP_HDB_DIRECTSALE} component={HDBReportRYP} />
      <Route exact path={BANK_PORTAL_REPORT_INFORCED_HDB_DIRECTSALE} component={HDBReportPolicyInforced} />
      <Route exact path={BANK_PORTAL_REPORT_POLICY_NEW_AGB} component={AGBReportPolicyNew} />
      <Route exact path={BANK_PORTAL_REPORT_FYP_AGB} component={AGBReportFYP} />
      <Route exact path={BANK_PORTAL_REPORT_LEAD_AGB} component={AGBReportLeadTracking} />
      <Route exact path={BANK_PORTAL_CONTEST_LIST} component={BPContestList} />
      <Route exact path={BANK_PORTAL_CONTEST_EDIT} component={BPContestEdit} />
      <Route exact path={BANK_PORTAL_CONTEST_CREATE} component={BPContestCreate} />
      <Route exact path={BANK_PORTAL_CONTEST_DETAIL} component={BPContestDetail} />
      <Route exact path={BANK_PORTAL_PHASE_CREATE} component={BPPhaseCreate} />
      <Route exact path={BANK_PORTAL_PHASE_DETAIL} component={BPPhaseDetail} />
      <Route exact path={BANK_PORTAL_PHASE_EDIT} component={BPPhaseEdit} />
      <Route exact path={BANK_PORTAL_CONTEST_FILE_CREATE} component={BPContestFileCreate} />
      <Route exact path={BANK_PORTAL_REPORT_HDB_POLICY_PROPOSAL} component={BPHDBReportProposal} />
      <Route exact path={BANK_PORTAL_REPORT_HDB_POLICY_ISSUE} component={BPHDBReportPolicyIssue} />
      <Route exact path={BANK_PORTAL_REPORT_HDB_POLICY_PENDING} component={BPHDBReportPolicyPending} />
      <Route exact path={BANK_PORTAL_REPORT_HDB_POLICY_CANCEL} component={BPHDBReportPolicyCancel} />
      <Route exact path={BANK_PORTAL_REPORT_HDB_POLICY_REJECT} component={BPHDBReportPolicyReject} />
      <Route exact path={BANK_PORTAL_REPORT_HDB_POLICY_FYP_DAILY} component={BPHDBReportPolicyFypDaily} />
      <Route exact path={BANK_PORTAL_REPORT_HDB_POLICY_FYP_MONTHLY} component={BPHDBReportPolicyFypMonthly} />
      <Route exact path={BANK_PORTAL_REPORT_HDB_POLICY_ISSUE_MONTHLY} component={BPHDBReportPolicyIssueMonthly} />
      <Route exact path={BANK_PORTAL_REPORT_HDB_POLICY_CUSTOMER_INFO} component={BPHDBReportPolicyCustomerInfo} />
      <Route exact path={BANK_PORTAL_REPORT_HDB_POLICY_LAPSE} component={BPHDBReportPolicyLapse} />
      <Route exact path={BANK_PORTAL_REPORT_HDB_POLICY_RENEWAL} component={BPHDBReportPolicyRenewal} />
      <Route exact path={BANK_PORTAL_REPORT_HDB_POLICY_REMIND_PAIDTODATE} component={BPHDBReportPolicyRemindPtd} />
      <Route exact path={BANK_PORTAL_REPORT_NAB_POLICY_NEW} component={NAB_ReportPolicyNew} />
      <Route exact path={BANK_PORTAL_REPORT_NAB_LEAD_TRACKING} component={NAB_ReportLeadTracking} />
      <Route exact path={BANK_PORTAL_REPORT_NAB_FYP} component={NAB_ReportFYP} />
      <Route exact path={BANK_PORTAL_REPORT_NAB_RYP} component={NAB_ReportRYP} />
      <Route exact path={BANK_PORTAL_REPORT_VCB_CUSTOMER_PRIORITY} component={BPVCBReportCustomerPriority} />

      <Route path={CORPORATE_LEAD_LIST} exact component={CorporateLeadList} />
      <Route path={CORPORATE_LEAD_NEW} exact component={CorporateLeadNew} />
      <Route path={CORPORATE_LEAD_VIEW} exact component={CorporateLeadView} />

        <Route exact path={BANK_PORTAL_REPORT_VCB_BOTO_SALE_PERFORMANCE} component={VcbBotoSalePerformance} />
        <Route exact path={BANK_PORTAL_REPORT_VCB_BANKER_SALE_PERFORMANCE} component={VcbBankerSalePerformance} />
        <Route exact path={BANK_PORTAL_SALE_PERFORMANCE_UPLOAD_LIST} component={VcbSalePerformanceUploadList} />
        <Route exact path={BANK_PORTAL_SALE_PERFORMANCE_UPLOAD_CREATE} component={VcbSalePerformanceUploadCreate} />
      <Route path='/' component={Home} />
    </Switch>
  );
};

const mapStateToProps = (state) => {
  let bank = state?.lookup?.bank;
  return { bank };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Routes);
